<template>
  <section>
    <b-modal width="680px" :active.sync="active">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title title">
            メディア選択
          </p>
        </header>
        <div style="padding: 8px; width: 100%; margin: 16px 0;" v-if="selectModalType=='image'">
          <b-upload accept="image/*" v-model="uploadedFile" @input="loadFile" v-if="!isConfirm">
            <a class="button is-fullwidth is-primary">
              <b-icon icon="upload"></b-icon>
              <span>新しく画像を追加する</span>
            </a>
          </b-upload>
          <b-loading
            :active="isLoading"
            :is-full-page="false">
          </b-loading>
          <b-field style="width: 30%; float: right;" v-if="isImageParts && !isRoboPartsSetView">
            <button class="button is-primary is-fullwidth" @click="changeConfirm();" v-if="!isConfirm">
              パーツ確定
            </button>
            <button class="button is-primary is-fullwidth" @click="changeConfirm();" v-else>
              パーツ確定解除
            </button>
          </b-field>
        </div>
        <div style="padding: 8px; width: 100%; margin: 16px 0;" v-if="selectModalType=='video'">
          <b-upload accept="video/*" v-model="uploadedFile" @input="loadFile">
            <a class="button is-fullwidth is-primary">
              <b-icon icon="upload"></b-icon>
              <span>新しく動画を追加する</span>
            </a>
          </b-upload>
          <b-loading
            :active="isLoading"
            :is-full-page="false">
          </b-loading>
        </div>

        <div style="width: 100%; display: flex; justify-content: center; margin: 16px 0;">
          <div>
            <div class="tabs is-toggle is-small">
              <ul>
                <li :class="{'is-active': !archiveSwitch}">
                  <a style="width: 128px;" @click="archiveSwitch=false"><span>一覧</span></a>
                </li>
                <li :class="{'is-active': archiveSwitch}">
                  <a style="width: 128px;" @click="archiveSwitch=true"><span>アーカイブ</span></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div style="margin-left:350px; margin-bottom:24px;">
          <b-autocomplete
            size="is-small"
            style="width: 250px; height: 27px; margin-left: 32px; margin-right: 8px;"
            v-model="autocompleteWords"
            placeholder="🔍タグ名またはファイル名で検索"
            :open-on-focus="true"
            :data="filteredTagsList"
            field="tag"
            @select="option => searchWords = option.tag">
          </b-autocomplete>
        </div>
        <div class="pagination-container">
          <b-pagination
            :total="sortArchive.length"
            :current.sync="pages"
            :per-page="12">
          </b-pagination>
          <!-- <input class="input is-small" style="width: 250px; margin-left: 32px; margin-right: 8px;" placeholder="🔍タグ名で検索" v-model="searchWords"/> -->
        </div>
        <div class="card-content scroll-box disp-scroll" v-if="active">
          <template v-if="selectModalType=='image'">
            <div class="button-overlay" v-for="(img, index) in sortArchive" :key="index" v-if="index >= ((pages - 1) * 12) && index < (pages * 12)">
              <img class="modal-media" :src="img.image_data" @click="selectMedia(img.pk)" onerror="this.style.display='none';nextElementSibling.style.display='none';" v-if="!isConfirm">
              <img class="modal-media-disabled" :src="img.image_data" onerror="this.style.display='none';nextElementSibling.style.display='none';" v-else>
              <a class="button is-small" @click="selectMedia(img.pk)" v-if="!isConfirm">
                <b-icon icon="upload"></b-icon>
                <span>選択</span>
              </a>
              <a class="button is-small" v-else disabled>
                <b-icon icon="upload"></b-icon>
                <span>選択</span>
              </a>
            </div>
          </template>
          <template v-if="selectModalType=='video'">
            <div class="button-overlay" v-for="(vdo, index) in sortArchive" :key="index" v-if="index >= ((pages - 1) * 12) && index < (pages * 12)">
              <video class="modal-media" :src="vdo.video_data" controls></video>
              <a class="button is-small" @click="selectMedia(vdo.pk)">
                <b-icon icon="upload"></b-icon>
                <span>選択</span>
              </a>
            </div>
          </template>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ModalSelectMedia',
  components:{
  },
  props: {
    isImageParts: {
      type    : Boolean,
      required: false
    },
    /** パーツ確定 */
    isConfirm: {
      type    : Boolean,
      required: false
    },
  },
  data () {
    return {
      active: false,
      name: '',
      uploadedFile: null,
      searchWords: null,
      archiveSwitch: false,
      pages: 1,
      autocompleteWords: '',
      searchTagList: []
    }
  },
  computed: {
    ...mapState('mediapool', ['images', 'videos', 'selectModalActive', 'selectModalType', 'selectModalTarget', 'isSelected', 'isLoading', 'selectMediaData']),
    ...mapState('chatbot', ['storyDialog', 'isRoboPartsSetView']),
    sortArchive () {
      let sortMedia = []
      if (this.selectModalType =='image') {
        for (let i of this.images) {
          if (i.is_archive === this.archiveSwitch && (this.searchWords && ((i.tags && i.tags.indexOf(this.searchWords) >= 0 || i.name.indexOf(this.searchWords) >= 0)) || !this.searchWords)) {
            sortMedia.push(i)
          }
        }
      } else if (this.selectModalType =='video') {
        for (let v of this.videos) {
          if (v.is_archive === this.archiveSwitch && (this.searchWords && ((i.tags && i.tags.indexOf(this.searchWords) >= 0 || i.name.indexOf(this.searchWords) >= 0)) || !this.searchWords)) {
            sortMedia.push(v)
          }
        }
      }
      return sortMedia
    },
    filteredTagsList() {
      // 入力された文字に一致するタグだけフィルタリング
      return this.searchTagList.filter((option) => {
        if (option.isArchive !== this.archiveSwitch) return false
        return option.tag
          .toString()
          .toLowerCase()
          .indexOf(this.autocompleteWords.toLowerCase()) >= 0
      })
    }
  },
  watch: {
    autocompleteWords () {
      // 直接b-autocompleteのv-modelにするとエラーになるので迂回して格納
      this.searchWords = this.autocompleteWords;
    },
    selectModalActive () {
      if (this.selectModalActive == false && this.isSelected==true) {
        //上位コンポーネントに通知
        if (this.selectModalType == 'image') {
            this.$emit('updated', this.selectModalTarget.data.image_id)
        }
        if (this.selectModalType == 'video') {
            this.$emit('updated', this.selectModalTarget.data.video_id)
        }
      }
      this.active = this.selectModalActive
      console.log(this.selectModalType)
    },
    active () {
      if (this.active == false) this.$store.dispatch('mediapool/closeSelectModal')
    },
    selectMediaData () {
      this.selectMedia(this.selectMediaData)
    }
  },
  methods: {
    loadFile (e) {
      if (!this.uploadedFile) return
      let createFile = new FormData()
      createFile.append('name', this.uploadedFile.name)
      if (this.selectModalType == 'image') {
        createFile.append('image_data', this.uploadedFile)
        this.$store.dispatch('mediapool/saveImage', createFile)
      } else if (this.selectModalType == 'video') {
        createFile.append('video_data', this.uploadedFile)
        this.$store.dispatch('mediapool/saveVideo', createFile)
      }
    },
    selectMedia (pk) {
        this.$store.dispatch('mediapool/selectMedia', pk)
        this.$store.dispatch('mediapool/closeSelectModal')
    },
    changeConfirm () {
      this.$emit('changeConfirm')
    }
  }
}
</script>

<style lang='scss' scoped>
.modal-media {
  height: 150px;
  margin: 8px;
  margin-right: 4px;
  cursor: pointer;
}
.modal-media-disabled {
  height: 150px;
  margin: 8px;
  margin-right: 4px;
}
.scroll-box {
  height: 500px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.title {
  font-size: 22px;
  font-weight: 700;
  padding: 20px;
  border-bottom: solid thin #ccc;
}
.card-header-title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.pagination-container {
  width: 80%;
  margin: auto;
  margin-bottom: 16px;
}
.button-overlay {
  position: relative;
  }
.button-overlay a {
  position: absolute;
  top: 10px;
  left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/ModalSelectMedia.vue